import { ThemeOptions } from "@mui/material/styles";

import { breakpoints } from "@/styles/breakpoints";

const theme: ThemeOptions = {
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: {
            xs: 0, // 600,//0,// 0,
            sm: 769, // 1024,//600, //320, //Iphone 5SE
            md: 1024, // 1280,//960,//600,
            lg: 1280, // 1400,//1024,
            xl: 1400, // 1920//1312
        },
    },
    direction: "ltr",
    mixins: {
        toolbar: {
            minHeight: 56,
            "@media (min-width:0px) and (orientation: landscape)": {
                minHeight: 48,
            },
            [`@media ${breakpoints.xxsMin}`]: {
                minHeight: 64,
            },
        },
    },
    shadows: [
        "none",
        "0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)",
        "0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)",
        "0px 1px 8px 0px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.12)",
        "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
        "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
        "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
        "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
        "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
        "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
        "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
        "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
        "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
        "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
        "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
        "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
        "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
        "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
        "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
        "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
        "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
        "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
        "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
        "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
        "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
    ],
    typography: {
        htmlFontSize: 16,
        fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: "bold",
            fontSize: "4.2rem",
            lineHeight: 1,
            letterSpacing: "-0.01562em",
            color: "var(--color-primary)",
        },
        h2: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: "bold",
            lineHeight: 1,
            letterSpacing: "-0.00833em",
            fontSize: "3.2rem",
            [`@media ${breakpoints.sm}`]: {
                fontSize: "var(--size-20)",
            },
            [`@media ${breakpoints.xs}`]: {
                fontSize: "var(--size-16)",
            },
        },
        h3: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: "3rem",
            lineHeight: 1.04,
            letterSpacing: "0em",
        },
        h4: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: "3.4rem",
            lineHeight: 1.17,
            letterSpacing: "0.00735em",
        },
        h5: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: "bold",
            fontSize: "2rem",
            lineHeight: 1.33,
            letterSpacing: "0em",
            color: "var(--color-grey-900)",
        },
        h6: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 500,
            fontSize: "1.25rem",
            lineHeight: 1.6,
            letterSpacing: "0.0075em",
        },
        subtitle1: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: "1.6rem",
            lineHeight: 1.75,
            letterSpacing: "0.00938em",
        },
        subtitle2: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 500,
            fontSize: "0.875rem",
            lineHeight: 1.57,
            letterSpacing: "0.00714em",
        },
        body1: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: "normal",
            fontSize: "1.6rem",
        },
        body2: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: "1.4rem",
        },
        button: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 500,
            fontSize: "1.4rem",
            lineHeight: 1.75,
            textTransform: "uppercase",
        },
        caption: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: "1.4rem",
        },
        overline: {
            fontFamily: '"Nexa", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: "0.75rem",
            lineHeight: 2.66,
            letterSpacing: "0.08333em",
            textTransform: "uppercase",
        },
    },
    shape: {
        borderRadius: 4,
    },
    transitions: {
        easing: {
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
            sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
        },
        duration: {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195,
        },
    },
    zIndex: {
        mobileStepper: 1000,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500,
    },

    components: {
        MuiTextField: {
            defaultProps: {
                variant: "outlined",
            },
        },
        MuiLink: {
            defaultProps: {
                underline: "none",
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: "1.4rem",
                    lineHeight: "1.9rem",
                    marginBottom: "5px",
                    fontStyle: "normal",
                    color: "var(--color-grey-800)",
                    [`@media ${breakpoints.smMin}`]: {
                        fontSize: "1.6rem",
                    },
                    "&.Mui-focused": {
                        color: "var(--color-primary)",
                    },
                },
                asterisk: {
                    color: "var(--color-warning)",
                },
            },
        },
        MuiFormControl: {
            defaultProps: {
                fullWidth: true,
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontSize: "var(--size-14)",
                    lineHeight: "1.9rem",
                    fontWeight: "600",
                    color: "var(--color-grey-800)",
                    [`@media ${breakpoints.xs}`]: {
                        fontSize: "var(--size-12)",
                        lineHeight: "16px",
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: "1.2rem",
                    lineHeight: "1.6rem",
                    marginLeft: "0",
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        padding: "0",
                    },
                },
                listbox: {
                    padding: "0",
                    "& .MuiAutocomplete-option": {
                        minHeight: "37px",
                        color: "var(--color-grey-900)",
                        lineHeight: "21px",
                        fontSize: "var(--size-14)",
                    },
                },
                tag: {
                    background: "var(--color-secondary-light)",
                    color: "var(--color-secondary)",
                    borderRadius: "var(--radius-10)",
                    fontSize: "var(--size-14)",
                    lineHeight: "var(--size-20)",
                    "& svg": {
                        width: "14px",
                        "& rect": {
                            fill: "var(--color-primary)",
                        },
                    },
                },
                groupLabel: {
                    backgroundColor: "var(--color-primary-extra-light)",
                    color: "var(--color-grey-800)",
                    minHeight: "37px",
                    lineHeight: "21px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "var(--size-14)",
                    "&:empty": {
                        display: "none",
                    },
                },
                popupIndicator: {
                    padding: "4px",
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary: {
                    "&$checked": {
                        color: "var(--color-secondary)",
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                colorSecondary: {
                    "&$checked": {
                        color: "var(--color-secondary)",
                    },
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                colorSecondary: {
                    color: "var(--color-secondary)",
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                track: {
                    "$checked$colorPrimary + &": {
                        opacity: 1.0,
                        backgroundColor: "var(--color-primary)",
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    minWidth: "auto",
                    "&.Mui-disabled": {
                        backgroundColor: "var(--color-grey-700)",
                        color: "var(--color-grey-900)",
                        opacity: "0.8",
                        "& svg path": {
                            fill: "var(--color-grey-800)",
                        },
                    },
                    "& svg": {
                        fontSize: "var(--size-20)",
                    },
                },
                input: {
                    lineHeight: "1.9rem",
                    fontSize: "var(--size-16)",
                    color: "var(--color-grey-900)",
                    padding: "10px",
                    [`@media ${breakpoints.sm}`]: {
                        fontSize: "var(--size-14)",
                    },
                    [`@media ${breakpoints.xs}`]: {
                        fontSize: "var(--size-16)",
                    },
                },
                multiline: {
                    padding: "10px",
                },
                inputMultiline: {
                    padding: "0",
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                outlined: { transform: "translate(0.9rem,-1.0rem) scale(0.8)" },
                shrink: { transform: "translate(0.9rem,-1.0rem) scale(0.8)" },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    height: "4px",
                    "& .MuiSlider-valueLabel": {
                        backgroundColor: "transparent",
                        "& .MuiSlider-valueLabelCircle": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "32px",
                            height: "32px",
                            borderRadius: "50% 50% 50% 0",
                            backgroundColor: "var(--color-secondary)",
                            transform: "rotate(-45deg)",
                        },
                        "& .MuiSlider-valueLabelLabel": {
                            color: "var(--color-white)",
                            fontSize: "var(--size-8)",
                            transform: "rotate(45deg)",
                        },
                    },
                },
                track: {
                    height: "4px",
                    borderRadius: "4px",
                },
                mark: {
                    height: "4px",
                    width: "4px",
                    borderRadius: "4px",
                },
                markLabel: {
                    color: "var(--color-grey-900)",
                },
                rail: {
                    height: "4px",
                    borderRadius: "4px",
                },
                colorPrimary: {
                    color: "var(--color-secondary)",
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    zIndex: "9000",
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                message: {
                    fontStyle: "italic",
                },
                standard: {
                    justifyContent: "space-between",
                    "& svg": {
                        alignSelf: "center",
                    },
                    "& .MuiAlert-action": {
                        padding: "0",
                        marginLeft: "16px",
                        alignSelf: "center",
                        "& svg": {
                            fontSize: "20px",
                        },
                    },
                },
                standardError: {
                    color: "var(--color-error)",
                    backgroundColor: "var(--color-error-light)",
                    "& svg": {
                        color: "var(--color-error)",
                    },
                },
                standardInfo: {
                    color: "var(--color-info)",
                    backgroundColor: "var(--color-info-light)",
                    "& svg": {
                        color: "var(--color-info)",
                    },
                },
                standardSuccess: {
                    color: "var(--color-success)",
                    backgroundColor: "var(--color-success-light)",
                    "& svg": {
                        color: "var(--color-success)",
                    },
                },
                standardWarning: {
                    color: "var(--color-warning)",
                    backgroundColor: "var(--color-warning-light)",
                    "& svg": {
                        color: "var(--color-warning)",
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "var(--color-white)",
                    borderRadius: "5px",
                    borderColor: "var(--color-grey-700)",
                    "&.Mui-disabled > .MuiOutlinedInput-notchedOutline": {
                        border: 0,
                    },
                    "&:hover > .MuiOutlinedInput-notchedOutline": { borderColor: "var(--color-secondary)" },
                    "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--color-secondary)",
                        borderWidth: "1px",
                    },
                    "& .MuiAutocomplete-input.MuiAutocomplete-input.MuiAutocomplete-input": {
                        padding: "10px 0px 10px 10px",
                    },
                },
                input: {
                    padding: "10px",
                },
                multiline: {
                    padding: "10px",
                },
                inputMultiline: {
                    padding: "0",
                },
            },
        },
        MuiGrid: {
            defaultProps: {
                rowSpacing: 1,
                columnSpacing: 2,
            },
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
            styleOverrides: {
                root: {
                    textTransform: "initial",
                    fontSize: "1.6rem",
                },
                outlinedPrimary: {
                    border: "2px solid var(--color-grey-700)",
                    color: "var(--color-secondary)",
                    padding: "4px 14px",
                    "&:hover": {
                        color: "var(--color-secondary-fg)",
                        backgroundColor: "var(--color-secondary-tint)",
                        padding: "5px 15px",
                        border: "1px solid var(--color-secondary-tint)",
                    },
                },
                containedPrimary: {
                    backgroundColor: "var(--color-secondary)",
                    color: "var(--color-secondary-fg)",
                    boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.15)",
                    "&:hover": {
                        boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.15)",
                        backgroundColor: "var(--color-secondary-tint)",
                    },
                    "&:active": {
                        boxShadow: "none",
                    },
                    "&.MuiButton-disableElevation": {
                        boxShadow: "none",
                    },
                    "&:disabled": {
                        backgroundColor: "var(--color-grey-700)",
                        color: "var(--color-white)",
                    },
                },
                containedSecondary: {
                    backgroundColor: "var(--color-tertiary)",
                    color: "var(--color-tertiary-fg)",
                    boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.15)",
                    "&:hover": {
                        boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.15)",
                        backgroundColor: "var(--color-tertiary-tint)",
                    },
                    "&:active": {
                        boxShadow: "none",
                    },
                    "&.MuiButton-disableElevation": {
                        boxShadow: "none",
                    },
                    "&:disabled": {
                        backgroundColor: "var(--color-grey-700)",
                        color: "var(--color-white)",
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: "4px",
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    color: "var(--color-grey-900)",
                    whiteSpace: "break-spaces",
                },
            },
        },
        // TABLE
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    backgroundColor: "var(--color-white)",
                    cursor: "auto",
                    borderBottom: "1px solid var(--color-grey-500)",
                    "&.MuiTableRow-hover:hover": {
                        cursor: "pointer",
                        backgroundColor: "var(--color-grey-500)",
                    },
                },
                head: {
                    backgroundColor: "var(--color-secondary-light)",
                    cursor: "auto",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: "none",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    [`@media ${breakpoints.xs}`]: {
                        whiteSpace: "normal",
                    },
                },
                body: {
                    color: "var(--color-grey-800)",
                },
            },
        },
    },
};

export default theme;
